import { Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuth } from './lib/auth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Playlists from './pages/Playlists'
import PlaylistDetail from './pages/PlaylistDetail'
import LectureDetail from './pages/LectureDetail'
import Queue from './pages/Queue'
import Settings from './pages/Settings'

function ProtectedApp() {
  const { user, loading, needsSetup } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-vertex-deep flex items-center justify-center">
        <div className="text-vertex-gold text-sm">جاري التحميل...</div>
      </div>
    )
  }

  if (!user || needsSetup) {
    return <Login />
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/playlists" element={<Playlists />} />
        <Route path="/playlists/:id" element={<PlaylistDetail />} />
        <Route path="/lectures/:id" element={<LectureDetail />} />
        <Route path="/queue" element={<Queue />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
    </Layout>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <ProtectedApp />
    </AuthProvider>
  )
}
